module.exports = __webpack_public_path__ + "static/media/press.9cf13eea.wav";